/* eslint-disable react/prop-types */
import React from "react";
/**
 * @typedef {object} EyeToggleProps
 * @property {string} [size]
 * @property {string} [fill]
 */

/**
 * @type {React.FC<EyeToggleProps & { [key: string]: any }>}
 */

export const EyeToggle = ({
  size,
  fill,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    id: `eye-toggle-${props.id || "icon"}`,
    className: "inline-block",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: `0 0 36.219 36.219`
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1945",
    d: `M0,0H36.219V36.219H0Z`,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1946",
    d: "M17.6,4.5A17.848,17.848,0,0,0,1,15.818a17.833,17.833,0,0,0,33.2,0A17.848,17.848,0,0,0,17.6,4.5Zm0,18.864a7.546,7.546,0,1,1,7.546-7.546A7.548,7.548,0,0,1,17.6,23.364Zm0-12.073a4.527,4.527,0,1,0,4.527,4.527A4.521,4.521,0,0,0,17.6,11.291Z",
    transform: "translate(0.509 2.291)",
    fill: fill
  }));
};
EyeToggle.defaultProps = {
  size: "24",
  fill: "#909090"
};